import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IMainStepData } from "../../models/freshman/mainStep";
import { freshmanMainStep } from "../../constants/apiUrl";
import { IDropdownData } from "../../models/ICommon";

export default new (class FreshmanMainStepService {
  public getMainStep = async (
    id: number
  ): Promise<IApiResponse<IMainStepData>> => {
    try {
      let endPoint = urlBinder(freshmanMainStep.GET_MAINSTEP, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IMainStepData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IMainStepData>;
      } else {
        throw error;
      }
    }
  };

  public getAllMainSteps = async (includeInactive?:boolean): Promise<IApiResponse<Array<IMainStepData>>> => {
    try {
      let endPoint = urlBinder(freshmanMainStep.GET_ALL_MAINSTEP, [[`${includeInactive ?? false}`]]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IMainStepData>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IMainStepData>>;
      } else {
        throw error;
      }
    }
  };

  public createMainStep = async (
    data: IMainStepData
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = freshmanMainStep.CREATE_MAINSTEP;
      const response = await APIService.post(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public updateMainStep = async (
    data: IMainStepData, id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(freshmanMainStep.UPDATE_MAINSTEP, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public inactiveMainStep = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(freshmanMainStep.INACTIVE_MAIN_STEP, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };

  public getAllMainStepsKeyValuePair = async (): Promise<IApiResponse<Array<IDropdownData>>> => {
    try {
      let endPoint = freshmanMainStep.KEY_VALUE_PAIR;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IDropdownData>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IDropdownData>>;
      } else {
        throw error;
      }
    }
  };
})();
